export enum ScheduledReportDateRangeStartEnum {
	XDaysBeforeReportRun = 0,
	StartOfLastMonth = 10,
}